export default {"src":"/_next/static/media/WhoWeAre_032A.01dbed5e.JPG","height":686,"width":1920};